<template>
  <div class="table-responsive-md">
    <table class="table mt-3 mb-2 align-middle">
      <thead>
      <tr>
        <th v-if="props.type !== 'long-haul'">{{ isDutch ? 'Vertrek' : 'Origin'}}</th>
        <th>{{ isDutch ? 'Bestemming' : 'Destination'}}</th>
        <th><span class="d-none d-md-inline">Flying Blue</span> Miles</th>
        <th>{{ isDutch ? 'Klasse' : 'Class'}}</th>
        <th>Airline</th>
        <th>Link</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="promoRewards && promoRewards.length > 0" v-for="promoReward in promoRewards">
        <td v-if="props.type !== 'long-haul'">
          <NuxtImg
              :src="promoReward.origin.city.country.flag"
              :alt="promoReward.origin.city.country.name + ' flag emoji'"
              class="d-block d-md-inline me-1"
              height="14"
              width="18"
              loading="lazy"
          />
          {{ promoReward.start }}
        </td>
        <td>
          <NuxtImg
              :src="promoReward.destination.city.country.flag"
              :alt="promoReward.destination.city.country.name + ' flag emoji'"
              class="d-block d-md-inline me-1"
              height="14"
              width="18"
              loading="lazy"
          />
          {{ isDutch ? promoReward.destination.city.name_nl : promoReward.destination.city.name }}
          <small>({{ promoReward.end }})</small>
        </td>
        <td>
          <span class="small">{{ isDutch ? 'Vanaf' : 'From'}} </span>
          {{ promoReward.miles.toLocaleString() }}
          <span class="small">Miles</span>
        </td>
        <td>{{ formatCabin(promoReward.cabin) }}</td>
        <td>
          <NuxtImg
              v-if="promoReward.airline === 'AF'"
              alt="Air France Logo"
              loading="lazy"
              class="me-2 position-relative"
              height="10"
              width="19"
              style="top: -1px"
              src="img/af-logo.svg"/>
          <NuxtImg
              v-else-if="promoReward.airline === 'KL'"
              alt="Air France Logo"
              loading="lazy"
              class="me-2 position-relative"
              height="10"
              width="19"
              style="top: -1px"
              src="img/klm-logo.svg"/>
          <span>{{ promoReward.airline }}</span>
        </td>
        <td>
          <NuxtLink
              :title="isDutch ? 'Vluchten vanaf ' + promoReward.origin.city.name_nl + ' naar ' + promoReward.destination.city.name_nl : 'Flights from ' + promoReward.origin.city.name + ' naar ' + promoReward.destination.city.name"
              :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: isDutch ? promoReward.origin.city.slug_nl : promoReward.origin.city.slug_en, iata: promoReward.origin.iata.toLowerCase(), toname: isDutch ? promoReward.destination.city.slug_nl : promoReward.destination.city.slug_en, toiata: promoReward.destination.iata.toLowerCase() } }">
            {{ isDutch ? 'Bekijk' : 'View'}}
          </NuxtLink>
        </td>
      </tr>
      <tr v-if="!promoRewards || promoRewards.length === 0">
        <td v-if="isDutch" class="text-center" colspan="6">
          De Promo Rewards voor {{ moment(props.month, 'MM').format('MMMM') }} zijn nog niet bekend. <br>Zodra deze bekend zijn updaten wij deze pagina.
        </td>
        <td v-else class="text-center" colspan="6">
          The Promo Rewards for {{ moment(props.month, 'MM').format('MMMM') }} have not been announced yet. <br>Once they are known, we will update this page.
        </td>
      </tr>
      </tbody>
      <caption v-if="promoRewards && props.type === 'long-haul'" class="alert alert-warning py-2 mt-3">
        {{ isDutch ? 'Langeafstandsvluchten zijn meestal beschikbaar vanaf elke Europese bestemming waar Air France of KLM vliegt.' : 'Long-haul flights are typically available from any European destination served by Air France or KLM.'}}
      </caption>
    </table>
  </div>
</template>

<script setup lang="ts">
import moment from "moment";

const isDutch = inject('isDutch');

const props = defineProps({
  month: String,
  year: String,
  type: String
});

const runtimeConfig = useRuntimeConfig()

const {data} = await useAsyncData(
    'promo-rewards-' + props.month + '-' + props.year + '-' + props.type + '-france',
    async () =>
        $fetch(runtimeConfig.public.backendUrl + "/api/v2/promo-rewards", {
          params: {
            'month': props.month,
            'year': props.year,
            'type': props.type,
            'include': 'france'
          }
        })
);

const promoRewards = data.value?.promo_rewards;

const formatCabin = (cabin: string) => {
  if (cabin === "Premium Economy") {
    return "Prem."
  }
  if (cabin === "Economy") {
    return "Eco."
  }
  if (cabin === "Business") {
    return "Biz."
  }
}

</script>